import React from 'react';
import { Input, Tooltip } from 'antd';
import FormItem from './FormItem';
import { TOOLTIP_TITLE } from '../constants';

const BaseInput = ({
  form,
  initialValue,
  label,
  name,
  rules,
  disabled,
  renderInput = () => <Input disabled={disabled} />,
}) => {
  const { getFieldDecorator } = form;

  return (
    <Tooltip
      placement="bottom"
      title={disabled ? TOOLTIP_TITLE : ''}
    >
      <FormItem label={label}>
        {getFieldDecorator(name, {
          initialValue: initialValue || '',
          rules,
        })(renderInput())}
      </FormItem>
    </Tooltip>
  );
};

export default BaseInput;
